module.exports = __webpack_public_path__ + "static/media/1.3 Wartung Servatius Datenlogger klein.6419e41f.jpg";